module.exports = "<div>\n  REQUEST ROUTE PLACEHOLDER\n</div>";